import { formatCurrency } from "@/lib/amortize";

// Pure SVG donut showing principal vs interest split.
export const DonutChart = ({ principal, interest }) => {
  const total = principal + interest;
  const principalPct = total > 0 ? principal / total : 0;
  const interestPct = total > 0 ? interest / total : 0;

  const r = 70;
  const circumference = 2 * Math.PI * r;
  const principalLen = principalPct * circumference;
  const interestLen = interestPct * circumference;

  return (
    <div className="flex flex-col items-center gap-6" data-testid="donut-chart">
      <div className="relative w-48 h-48 flex items-center justify-center">
        <svg className="absolute inset-0 w-full h-full -rotate-90" viewBox="0 0 180 180">
          <circle cx="90" cy="90" r={r} className="fill-transparent stroke-slate-100" strokeWidth="16" />
          <circle
            cx="90"
            cy="90"
            r={r}
            className="fill-transparent stroke-[#4AAFC9] transition-all duration-1000 ease-out"
            strokeWidth="16"
            strokeLinecap="round"
            strokeDasharray={`${principalLen} ${circumference}`}
          />
          <circle
            cx="90"
            cy="90"
            r={r}
            className="fill-transparent stroke-[#85B7EB] transition-all duration-1000 ease-out"
            strokeWidth="16"
            strokeLinecap="round"
            strokeDasharray={`${interestLen} ${circumference}`}
            strokeDashoffset={-principalLen}
          />
        </svg>
        <div className="text-center">
          <div className="text-xs font-bold text-slate-400 uppercase tracking-widest">Total paid</div>
          <div className="text-2xl font-semibold text-slate-900 tabular-nums">{formatCurrency(total, 0)}</div>
        </div>
      </div>

      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2" data-testid="legend-principal">
          <span className="w-3 h-3 rounded-full bg-[#4AAFC9]" />
          <div>
            <div className="text-xs font-bold text-slate-500 uppercase tracking-widest">Principal</div>
            <div className="text-sm font-semibold text-slate-900 tabular-nums">
              {formatCurrency(principal, 0)} · {Math.round(principalPct * 100)}%
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2" data-testid="legend-interest">
          <span className="w-3 h-3 rounded-full bg-[#85B7EB]" />
          <div>
            <div className="text-xs font-bold text-slate-500 uppercase tracking-widest">Interest</div>
            <div className="text-sm font-semibold text-slate-900 tabular-nums">
              {formatCurrency(interest, 0)} · {Math.round(interestPct * 100)}%
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
